import styled, { css } from 'styled-components';

import { newTableTokens } from '../../../tokens/components/NewTable/tokens';
import { NewTableRowProps } from '../NewTable';
import { NewTableVirtualContextType } from '../components/NewTableVirtualWrapper/NewTableVirtualWrapper';

/* @internal */
const CoreRow = styled.tr<NewTableRowProps & { virtual?: NewTableVirtualContextType }>`
  &[role='button'] {
    cursor: pointer;
    outline: 0;
  }

  ${({ virtual }) =>
    virtual &&
    `
    display: flex;
    width: 100%;
    ${virtual?.section === 'body' && `position: absolute;`}
  `}

  /*
    Tables are borderless, so we add borders to all nested Twiddle rows;

    However, we must remove borders from:
    - Top level twiddle rows (identified by its ability to be clicked)
    - Top level twiddle rows (via Twiddle button handler)
    - Nested NewTables (blanket removal until requested)
  */
  ${({ theme }) =>
    !!theme.twiddleLevel &&
    css`
      border-left: 1px solid ${newTableTokens.CellBorderColorBaseDefault};
      border-right: 1px solid ${newTableTokens.CellBorderColorBaseDefault};

      ${theme.twiddleLevel === 1 &&
      css`
        &:has(button[class^='StyledTwiddleIconButton']),
        &[role='button'] {
          border-left: 0;
          border-right: 0;
        }
      `};

      table tr {
        border-left: 0;
        border-right: 0;
      }
    `}
`;

export default CoreRow;
